export default {
  setItems(state, items) {
    state.items = items;
  },
  setBanks(state, banks) {
    state.banks = banks;
  }
};
